
const initialState = {
    hobbies: [],
};

const hobbiesReducer = (state = initialState, action) => {
    switch (action.type) {
        case "ADD_HOBBIES_NAME":
            return state = {
                ...state,
                hobbies: [action.payload, ...state.hobbies ],
            }
        case "UPDATE_HOBBIES_NAME":
            return state = { ...state, hobbies: state?.hobbies?.map((hobbies) => hobbies._id === action.payload._id ? action?.payload : hobbies)}

        case "UPDATE_HOBBIES_STATUS":
            return state = {
                ...state,
                hobbies: state?.hobbies?.map((hobbies) =>
                    hobbies._id === action.payload._id ? action?.payload : hobbies
                ),
            }
            case "GET_ALL_HOBBIES":
                return {
                    ...state,
                    hobbies: action.payload,
                };
        default:
            return state;
    }
}

export default hobbiesReducer;